// Module
var code = "<div id=\"brs-tabstrip\">\n\t<ul>\n\t\t<li class=\"k-state-active\">Projects</li>\n\t\t<li>Inventory</li>\n\t</ul>\n\t<div id=\"brs-projects-content\">\n\n\t</div>\n\t<div id=\"brs-inventory-content\">\n\n\t</div>\n</div>\n";
// Exports
export default code;